import { render } from "./AppsSidebar.vue?vue&type=template&id=9e94250a&scoped=true"
import script from "./AppsSidebar.vue?vue&type=script&lang=js"
export * from "./AppsSidebar.vue?vue&type=script&lang=js"

import "./AppsSidebar.vue?vue&type=style&index=0&id=9e94250a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e94250a"]])

export default __exports__